import { render } from "./SongsList.vue?vue&type=template&id=be5c93ec"
import script from "./SongsList.vue?vue&type=script&lang=js"
export * from "./SongsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__